var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"gh-button-email",attrs:{"href":_vm.href}},[_vm._t("default",function(){return [_c('v-icon',[_vm._v("send")]),_vm._v(" "+_vm._s(_vm.emailAddress)+"\n  ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }